import axios from "axios";

export const DEFAULT_DAYS_NUMBER = 7;

export default class MenuService {
    fetchMenus(patientId, params = {}) {
        return axios.get(`/v2/patients/${patientId}/menu`, {params: params});
    }

    deleteMenu(patientId, menuId) {
        return axios.delete(`/v2/patients/${patientId}/menu/${menuId}`);
    }

    fetchDietAssumptions(patientId) {
        return axios.get(`/v2/patients/${patientId}/menu/diet-assumptions`);
    }

    saveMenu(patientId, menu) {
        return axios.post(`/v2/patients/${patientId}/menu`, menu);
    }

    updateMenu(patientId, menuId, menu) {
        return axios.patch(`/v2/patients/${patientId}/menu/${menuId}`, menu);
    }

    scaleMenu(patientId, menuId, menu) {
        return axios.post(`/v2/patients/${patientId}/menu/${menuId}/scale`, menu);
    }

    sendToMobileApp(patientId, menuId) {
        return axios.post(`/v2/patients/${patientId}/menu/${menuId}/send`);
    }

    deleteFromMobileApp(patientId, menuId) {
        return axios.delete(`/v2/patients/${patientId}/menu/${menuId}/send`);
    }

    updateInMobileApp(patientId, menuId) {
        return axios.patch(`/v2/patients/${patientId}/menu/${menuId}/send`);
    }
}
